import React from 'react'
import { IoAddSharp } from "react-icons/io5";

function CriticalFinding() {
    return (
        <div className="dark:bg-gray-900">
           
            <div className='bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-3xl mt-10 p-2 shadow-sm dark:shadow-gray-900'>

                <div className='bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2'>
                    <div>
                        <h1 className="text-gray-900 dark:text-gray-100 font-semibold">Finding code</h1>
                    </div>
                    <h1 className='mt-3 text-gray-700 dark:text-gray-300'>Select Finding Code</h1>
                    <div className='flex gap-1'>

                        <div className='bg-white dark:bg-gray-800 px-3 rounded-full h-11 w-80 text-[#5F6368] dark:text-gray-300 place-content-center mt-3 shadow-sm dark:shadow-gray-900'>
                            <h1>Finding code</h1>
                        </div>
                        <div className='bg-white dark:bg-gray-800 px-3 rounded-full h-11 w-11 place-content-center mt-3 justify-items-center shadow-sm dark:shadow-gray-900 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer'>
                            <IoAddSharp />
                        </div>

                    </div>

                </div>
                <div className='bg-gray-200 dark:bg-gray-700 border dark:border-gray-600 rounded-3xl p-6 mt-2'>
                    <div>
                        <h1 className="text-gray-900 dark:text-gray-100 font-semibold">Finding description</h1>
                    </div>
                    <h1 className='mt-3 text-gray-700 dark:text-gray-300'>Select Finding description</h1>
                    <div className='flex gap-1'>

                        <div className='bg-white dark:bg-gray-800 xl:px-3 p-6 xl:p-1 rounded-3xl xl:rounded-full h-auto xl:h-11 w-full text-[#5F6368] dark:text-gray-300 place-content-center mt-3 shadow-sm dark:shadow-gray-900'>
                            <h1>View the preview screen to see your pet's leg scans. Keep an eye on mobility changes, especially if there's limping or discomfort.</h1>
                        </div>
                        <div className='bg-white dark:bg-gray-800 px-3 rounded-full h-11 w-11 place-content-center mt-3 justify-items-center shadow-sm dark:shadow-gray-900 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer'>
                            <IoAddSharp />
                        </div>

                    </div>

                </div>

            </div>
          
        </div>
    )
}

export default CriticalFinding
